import { UserModel } from '@/models';

export const mapUser = (user): UserModel => {
  if (user) {
    Object.keys(user).forEach((k) => {
      if (user.hasOwnProperty(k) && !user[k]) {
        user[k] = '';
      }
    });

    if (user.birthday?.length) {
      // Remove TZ because of a parse error on Safari
      user.birthday = new Date(user.birthday.split('+')[0]);
    }

    // SMK-41: quick fix to prevent addresses errors
    if (!Array.isArray(user.addresses)) {
      user.addresses = [];
    }

    delete user.password;
  }

  return user;
};
